import React from 'react';
import classNames from 'classnames';

function StorePickupOptionsTemplate ({ helpers, modelAttributes }) {

	const {
		formattedPhoneNumber,
		id,
		includeStoreNumber,
		isSelected,
		isStoreInventory,
		shortSku,
		showMyStoreLabel,
		showThisStoreLabel
	} = helpers;

	const {
		StoreArrivalDate, StoreNumber, StoreName, StreetAddress
	} = modelAttributes;

	const dataStoreAttributeValueStoreNumber = includeStoreNumber ? `#${StoreNumber}` : '';
	const dataStoreAttributeValue = `${StoreName}${dataStoreAttributeValueStoreNumber}}`;
	const dataShortSku = shortSku ? { 'data-shortsku': shortSku } : {};

	const shippingOptionRadioClassName = classNames(
		'store-pickup-list__radio',
		'jsStorePickupRadio',
		isStoreInventory && 'jsStoreInventoryRadio'
	);

	let storeLabel = '';
	if (showThisStoreLabel) {

		storeLabel = 'This Store';

	} else if (showMyStoreLabel) {

		storeLabel = 'My Store';

	}

	return (
		<>
			<input
				type="radio"
				id={`store-${id}`}
				name="shippingOptionRadio"
				className={shippingOptionRadioClassName}
				defaultValue={StoreNumber}
				data-store={dataStoreAttributeValue}
				{...dataShortSku}
				defaultChecked={isSelected}
			/>
			<label htmlFor={`store-${id}`} className="store-pickup-list__label group">
				<span className="store-pickup-list__name">
					{StoreName}
					{' Store'}
					{isStoreInventory && ` #${StoreNumber}`}
				</span>
				<span className="store-pickup-list__address">
					{StreetAddress}
					{formattedPhoneNumber}
				</span>
				<div className="store-pickup-list__storeLabel">
					{storeLabel}
				</div>
				{!isStoreInventory && (
					<div className="store-pickup-list__days">
						{'Arrives '}
						{StoreArrivalDate}
					</div>
				)}
			</label>
		</>
	);

}

export default StorePickupOptionsTemplate;
